export default __webpack_public_path__ + "static/media/foodBg.5df767de.jpg";